import Vue from 'vue';

export default function() {
	Vue.$ofsCrud.addResource({
		name: 'psp',
		pluralName: 'psps',
		transport: 'davinci',
		options: {
			namespaced: true
		}
	});
}
